import React, { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

const Workspace = () => {
  const history = useHistory();
  const { url } = useRouteMatch();
  useEffect(() => {
    // For now, redirect to BeatsHome when accessing workspace
    // In the future, this could be the active project workspace
    const timer = setTimeout(() => {
      history.push(url.replace('/workspace', ''));
    }, 1000);

    return () => clearTimeout(timer);
  }, [history, url]);

  return (
    <Container fluid className="py-4 beats-component-container">
      <Row className="justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Col md={6} className="text-center">
          <Spinner animation="border" className="mb-3" style={{ color: 'var(--purple-accent)' }} />
          <h4 className="mb-3">Loading Workspace...</h4>
          <p className="text-muted">
            Redirecting you to your active workspace
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Workspace; 